import React from "react";
import { useSdkContext } from "~/components/contexts";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const ScmpPlusButton = ({
  className
}) => {
  const {
    handleTrackGA4
  } = useSdkContext();
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    onClick: () => {
      handleTrackGA4({
        action: "click",
        category: "plus",
        subcategory: "masthead"
      });
      const url = new URL("/plus", location.origin);
      const searchParameters = new URL(location.href).searchParams;
      url.search = searchParameters.toString();
      window.location.href = url.toString();
    },
    "data-qa": "scmp-plus-button"
  }, "SCMP ", /*#__PURE__*/React.createElement("i", null, "Plus"));
};
ScmpPlusButton.displayName = "ScmpPlusButton";